import { useSearchParams } from "react-router-dom";
import { Box, Calculator, LayoutGrid, Layers, Ruler } from "lucide-react";
import { DielineTool } from "./DielineTool";
import { ImpositionTool } from "./ImpositionTool";
import { PaperTool } from "./PaperTool";
import { ReelTool } from "./ReelTool";
import { ConverterTool } from "./ConverterTool";

const TOOLS = [
  { id: "dieline", label: "Dieline generator", icon: Box, desc: "2D dielines with a folding 3D preview. Download PDF, SVG or DXF.", C: DielineTool },
  { id: "imposition", label: "Imposition & sheet layout", icon: LayoutGrid, desc: "Ups per sheet, best layout, sheets needed and paper cost.", C: ImpositionTool },
  { id: "paper", label: "GSM, ream & sheet weight", icon: Layers, desc: "Sheet and ream weights, sheets per kg, GSM ↔ lb.", C: PaperTool },
  { id: "reel", label: "Reel / roll calculator", icon: Calculator, desc: "Outer diameter, length and weight of film and label rolls.", C: ReelTool },
  { id: "converter", label: "Unit converter", icon: Ruler, desc: "Inches ↔ mm/cm, weight, area, thickness, volume, temperature.", C: ConverterTool },
];

export default function PrintTools() {
  const [params, setParams] = useSearchParams();
  const active = TOOLS.find(t => t.id === params.get("tool")) || TOOLS[0];
  const pick = (id) => { const p = new URLSearchParams(params); p.set("tool", id); setParams(p); };
  return (
    <section className="content" data-testid="print-tools">
      <p className="eyebrow" style={{ margin: 0 }}>Print tools</p>
      <h1 style={{ fontSize: 28, fontWeight: 800, margin: "4px 0 6px" }}>Calculators & dieline studio</h1>
      <p style={{ color: "#64748b", fontSize: 13.5, margin: "0 0 18px" }}>Free for every account. All calculations run in your browser.</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 10, marginBottom: 20 }}>
        {TOOLS.map(t => {
          const on = t.id === active.id, I = t.icon;
          return (
            <button key={t.id} data-testid={`tool-tab-${t.id}`} onClick={() => pick(t.id)}
              style={{ textAlign: "left", border: `1.5px solid ${on ? "#1D4ED8" : "#E2E8F0"}`, background: on ? "#EFF6FF" : "#fff", borderRadius: 12, padding: "12px 14px", cursor: "pointer", transition: "border-color .15s, background-color .15s" }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 800, fontSize: 13, color: on ? "#1D4ED8" : "#0F172A" }}><I size={16}/>{t.label}</div>
              <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 4 }}>{t.desc}</div>
            </button>
          );
        })}
      </div>
      <active.C/>
    </section>
  );
}
